<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="ch00_fm04_copy"></a><a id="page_iv"></a><strong>Note to the reader:</strong> This book describes how to help prevent infections in children <em>in general.</em> It was not written about <em>your</em> child. You should obtain the services of a competent professional whenever you need medical or other specific advice.</p>
<p class="copyright">Dr. Kourtis’s work was performed outside the scope of her employment as a U.S. government employee. Her work represents her personal and professional views and not necessarily those of the U.S. Centers for Disease Control and Prevention.</p>
<p class="copyright">© 2011 Athena P. Kourtis<br/>All rights reserved. Published 2011<br/>Printed in the United States of America on acid-free paper<br/>2 4 6 8 9 7 5 3 1</p>
<p class="copyright">The Johns Hopkins University Press<br/>2715 North Charles Street<br/>Baltimore, Maryland 21218-4363<br/><span class="weblink"><a class="nounder" href="http://www.press.jhu.edu" target="_blank">www.press.jhu.edu</a></span></p>
<p class="copyright"><em>Library of Congress Cataloging-in-Publication Data</em></p>
<p class="copyrightv">Kourtis, Athena P.</p>
<p class="copyrightva">Keeping your child healthy in a germ-filled world : a guide for parents / Athena P. Kourtis.</p>
<p class="copyrightvb">p. cm. (A Johns Hopkins Press health book)</p>
<p class="copyrightva">Includes bibliographical references and index.</p>
<p class="copyrightva">ISBN-13: 978-1-4214-0211-6 (hardcover : alk. paper)</p>
<p class="copyrightva">ISBN-13: 978-1-4214-0212-3 (pbk. : alk. paper)</p>
<p class="copyrightva">ISBN-10: 1-4214-0211-4 (hardcover : alk. paper)</p>
<p class="copyrightva">ISBN-10: 1-4214-0212-2 (pbk. : alk. paper)</p>
<p class="copyrightva">1. Self-care, Health—Popular works. 2. Microorganisms—Popular works. I. Title.</p>
<p class="copyrightva">RA776.95.K68 2011</p>
<p class="copyrightva">613—dc22      2011004100</p>
<p class="copyright">A catalog record for this book is available from the British Library.</p>
<p class="copyright">Illustrations by Elizabeth Allen</p>
<p class="copyright"><em>Special discounts are available for bulk purchases of this book.<br/>For more information, please contact Special Sales<br/>at 410-516-6936 or specialsales@press.jhu.edu.</em></p>
<p class="copyright">The Johns Hopkins University Press uses environmentally friendly<br/>book materials, including recycled text paper that is composed of at<br/>least 30 percent post-consumer waste, whenever possible.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04_copy.vue?2592d922